import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn_next = _resolveComponent("v-btn-next")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list_item_subtitle = _resolveComponent("v-list-item-subtitle")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_window_item = _resolveComponent("v-window-item")!
  const _component_v_btn_back = _resolveComponent("v-btn-back")!
  const _component_v_switch = _resolveComponent("v-switch")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_text_field_filled = _resolveComponent("v-text-field-filled")!
  const _component_v_checkbox = _resolveComponent("v-checkbox")!
  const _component_v_virtual_scroll = _resolveComponent("v-virtual-scroll")!
  const _component_v_window = _resolveComponent("v-window")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createBlock(_component_v_window, {
    modelValue: _ctx.profileEditionStep,
    "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.profileEditionStep) = $event))
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_window_item, {
        transition: "slide-x-transition",
        value: 'main'
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_row, {
            "no-gutters": "",
            rounded: ""
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, {
                cols: "12",
                rounded: ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_list, {
                    subheader: "",
                    lines: "two"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_list_item, {
                        class: "oss-list-item mb-2 mt-2",
                        onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.profileEditionStep = 'openpoints'), ["stop"]))
                      }, {
                        prepend: _withCtx(() => [
                          _createVNode(_component_v_icon, { color: "primary" }, {
                            default: _withCtx(() => _cache[24] || (_cache[24] = [
                              _createTextVNode("$oss-analysis")
                            ])),
                            _: 1
                          })
                        ]),
                        append: _withCtx(() => [
                          _createVNode(_component_v_btn_next)
                        ]),
                        default: _withCtx(() => [
                          _createVNode(_component_v_list_item_title, null, {
                            default: _withCtx(() => _cache[25] || (_cache[25] = [
                              _createTextVNode(" Gestion des en cours ")
                            ])),
                            _: 1
                          }),
                          _createVNode(_component_v_list_item_subtitle, null, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.subTitleOpenpoints), 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_list_item, {
                        class: "oss-list-item mb-2",
                        onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.profileEditionStep = 'payments'), ["stop"]))
                      }, {
                        prepend: _withCtx(() => [
                          _createVNode(_component_v_icon, { color: "primary" }, {
                            default: _withCtx(() => _cache[26] || (_cache[26] = [
                              _createTextVNode("$oss-bank")
                            ])),
                            _: 1
                          })
                        ]),
                        append: _withCtx(() => [
                          _createVNode(_component_v_btn_next)
                        ]),
                        default: _withCtx(() => [
                          _createVNode(_component_v_list_item_title, null, {
                            default: _withCtx(() => _cache[27] || (_cache[27] = [
                              _createTextVNode(" Gestion des paiements ")
                            ])),
                            _: 1
                          }),
                          _createVNode(_component_v_list_item_subtitle, null, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.subTitlePayments), 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_list_item, {
                        class: "oss-list-item mb-2",
                        onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.profileEditionStep = 'validation'), ["stop"]))
                      }, {
                        prepend: _withCtx(() => [
                          _createVNode(_component_v_icon, { color: "primary" }, {
                            default: _withCtx(() => _cache[28] || (_cache[28] = [
                              _createTextVNode("$fa-file-contract")
                            ])),
                            _: 1
                          })
                        ]),
                        append: _withCtx(() => [
                          _createVNode(_component_v_btn_next)
                        ]),
                        default: _withCtx(() => [
                          _createVNode(_component_v_list_item_title, null, {
                            default: _withCtx(() => _cache[29] || (_cache[29] = [
                              _createTextVNode(" Gestion de la validation ")
                            ])),
                            _: 1
                          }),
                          _createVNode(_component_v_list_item_subtitle, null, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.subTitleValidation), 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_v_window_item, {
        transition: "slide-x-transition",
        value: 'openpoints'
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_row, { "no-gutters": "" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, {
                cols: "12",
                class: "rounded"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_btn_back, {
                    onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_ctx.profileEditionStep = 'main'), ["stop"]))
                  }),
                  _cache[38] || (_cache[38] = _createElementVNode("span", { class: "title ml-2" }, "Gestion des en cours", -1)),
                  _createVNode(_component_v_list, {
                    subheader: "",
                    class: "mt-2",
                    lines: "two"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_list_item, {
                        class: "oss-list-item mb-2 mt-2",
                        onClick: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (_ctx.profileEditionStep = 'openpoints-clients'), ["stop"]))
                      }, {
                        prepend: _withCtx(() => [
                          _createVNode(_component_v_icon, { color: "primary" }, {
                            default: _withCtx(() => _cache[30] || (_cache[30] = [
                              _createTextVNode("$fa-building")
                            ])),
                            _: 1
                          })
                        ]),
                        append: _withCtx(() => [
                          _createVNode(_component_v_btn_next)
                        ]),
                        default: _withCtx(() => [
                          _createVNode(_component_v_list_item_title, null, {
                            default: _withCtx(() => _cache[31] || (_cache[31] = [
                              _createTextVNode("Clients ")
                            ])),
                            _: 1
                          }),
                          _createVNode(_component_v_list_item_subtitle, null, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.subTitleOpenpointsCustomer), 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_list_item, { class: "oss-list-item mb-2" }, {
                        prepend: _withCtx(() => [
                          _createVNode(_component_v_icon, { color: "primary" }, {
                            default: _withCtx(() => _cache[32] || (_cache[32] = [
                              _createTextVNode("$fa-building")
                            ])),
                            _: 1
                          })
                        ]),
                        append: _withCtx(() => [
                          _createVNode(_component_v_switch, {
                            modelValue: _ctx.companyUser.configuration.outstanding.supplier,
                            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.companyUser.configuration.outstanding.supplier) = $event)),
                            "hide-details": "",
                            class: "my-0",
                            ripple: false,
                            readonly: !_ctx.isEditable
                          }, null, 8, ["modelValue", "readonly"])
                        ]),
                        default: _withCtx(() => [
                          _createVNode(_component_v_list_item_title, null, {
                            default: _withCtx(() => _cache[33] || (_cache[33] = [
                              _createTextVNode(" Fournisseurs ")
                            ])),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_list_item, { class: "oss-list-item mb-2" }, {
                        prepend: _withCtx(() => [
                          _createVNode(_component_v_icon, { color: "primary" }, {
                            default: _withCtx(() => _cache[34] || (_cache[34] = [
                              _createTextVNode("$oss-expense-report")
                            ])),
                            _: 1
                          })
                        ]),
                        append: _withCtx(() => [
                          _createVNode(_component_v_switch, {
                            modelValue: _ctx.companyUser.configuration.outstanding.expenseReport,
                            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.companyUser.configuration.outstanding.expenseReport) = $event)),
                            "hide-details": "",
                            class: "my-0",
                            ripple: false,
                            readonly: !_ctx.isEditable
                          }, null, 8, ["modelValue", "readonly"])
                        ]),
                        default: _withCtx(() => [
                          _createVNode(_component_v_list_item_title, null, {
                            default: _withCtx(() => _cache[35] || (_cache[35] = [
                              _createTextVNode(" Note de frais ")
                            ])),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_list_item, { class: "oss-list-item mb-2" }, {
                        prepend: _withCtx(() => [
                          _createVNode(_component_v_icon, { color: "primary" }, {
                            default: _withCtx(() => _cache[36] || (_cache[36] = [
                              _createTextVNode("$fa-hand-holding-usd")
                            ])),
                            _: 1
                          })
                        ]),
                        append: _withCtx(() => [
                          _createVNode(_component_v_switch, {
                            modelValue: _ctx.companyUser.configuration.outstanding.salary,
                            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.companyUser.configuration.outstanding.salary) = $event)),
                            "hide-details": "",
                            class: "my-0",
                            ripple: false,
                            readonly: !_ctx.isEditable
                          }, null, 8, ["modelValue", "readonly"])
                        ]),
                        default: _withCtx(() => [
                          _createVNode(_component_v_list_item_title, null, {
                            default: _withCtx(() => _cache[37] || (_cache[37] = [
                              _createTextVNode(" Salaire ")
                            ])),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_v_window_item, {
        transition: "slide-x-transition",
        value: 'openpoints-clients'
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_row, {
            "no-gutters": "",
            class: "py-2"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, { cols: "6" }, {
                default: _withCtx(() => [
                  (!_ctx.invoiceMode)
                    ? (_openBlock(), _createBlock(_component_v_btn_back, {
                        key: 0,
                        onClick: _cache[8] || (_cache[8] = _withModifiers(($event: any) => (_ctx.profileEditionStep = 'openpoints'), ["stop"]))
                      }))
                    : _createCommentVNode("", true),
                  _cache[39] || (_cache[39] = _createElementVNode("span", { class: "title ml-2" }, "Encours Clients ", -1))
                ]),
                _: 1
              }),
              _createVNode(_component_v_col, {
                cols: "3",
                class: "d-flex align-center"
              }, {
                default: _withCtx(() => [
                  _withDirectives(_createVNode(_component_v_switch, {
                    modelValue: _ctx.outstandingClient,
                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.outstandingClient) = $event)),
                    "hide-details": "",
                    class: "my-0",
                    label: "Activer pour tous les clients",
                    ripple: false,
                    readonly: !_ctx.isEditable
                  }, null, 8, ["modelValue", "readonly"]), [
                    [_directive_tooltip, 'y compris les futurs clients créés']
                  ])
                ]),
                _: 1
              }),
              (_ctx.invoiceMode)
                ? (_openBlock(), _createBlock(_component_v_col, {
                    key: 0,
                    cols: "2",
                    class: "d-flex align-end justify-end"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_btn, {
                        rounded: "",
                        elevation: "0",
                        disabled: !_ctx.isEditable,
                        onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.upsertCompanyUser())),
                        size: "small"
                      }, {
                        default: _withCtx(() => _cache[40] || (_cache[40] = [
                          _createTextVNode(" Enregistrer ")
                        ])),
                        _: 1
                      }, 8, ["disabled"])
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          (!_ctx.outstandingClient)
            ? (_openBlock(), _createBlock(_component_v_row, {
                key: 0,
                "no-gutters": "",
                class: "py-2"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, { cols: "4" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_text_field_filled, {
                        modelValue: _ctx.clientSearch,
                        "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.clientSearch) = $event)),
                        label: "Rechercher",
                        "append-inner-icon": "$search",
                        outlined: "",
                        "hide-details": "",
                        density: "compact",
                        clearable: "",
                        "onClick:clear": _cache[12] || (_cache[12] = ($event: any) => (_ctx.clientSearch = ''))
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_col, { class: "pl-2 d-flex align-center" }, {
                    default: _withCtx(() => [
                      (_ctx.selectedClients.length > 0)
                        ? (_openBlock(), _createBlock(_component_v_btn, {
                            key: 0,
                            onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.diselectAllClients())),
                            size: "small",
                            disabled: !_ctx.isEditable
                          }, {
                            default: _withCtx(() => _cache[41] || (_cache[41] = [
                              _createTextVNode(" Aucun client ")
                            ])),
                            _: 1
                          }, 8, ["disabled"]))
                        : (_openBlock(), _createBlock(_component_v_btn, {
                            key: 1,
                            class: "mr-2",
                            onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.selectAllClients())),
                            size: "small",
                            disabled: !_ctx.isEditable
                          }, {
                            default: _withCtx(() => _cache[42] || (_cache[42] = [
                              _createTextVNode(" Sélectionner tous les clients ")
                            ])),
                            _: 1
                          }, 8, ["disabled"]))
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createVNode(_component_v_row, { "no-gutters": "" }, {
            default: _withCtx(() => [
              (!_ctx.pairedClientCompanies.length)
                ? (_openBlock(), _createBlock(_component_v_col, {
                    key: 0,
                    cols: "12"
                  }, {
                    default: _withCtx(() => _cache[43] || (_cache[43] = [
                      _createTextVNode(" Aucun client trouvé ")
                    ])),
                    _: 1
                  }))
                : (_ctx.outstandingClient)
                  ? (_openBlock(), _createBlock(_component_v_col, {
                      key: 1,
                      cols: "12"
                    }, {
                      default: _withCtx(() => _cache[44] || (_cache[44] = [
                        _createTextVNode(" Tous les clients sont sélectionnés ")
                      ])),
                      _: 1
                    }))
                  : (_openBlock(), _createBlock(_component_v_col, { key: 2 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_virtual_scroll, {
                          items: _ctx.pairedClientCompanies,
                          "item-height": 66,
                          height: `min(${_ctx.pairedClientCompanies.length * 66}px, calc(100vh - 280px) )`,
                          width: "100%"
                        }, {
                          default: _withCtx(({ item }) => [
                            _createVNode(_component_v_row, { "no-gutters": "" }, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item, (comp) => {
                                  return (_openBlock(), _createBlock(_component_v_col, {
                                    cols: "6",
                                    key: comp.id,
                                    class: "pr-2 pb-2"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_list_item, {
                                        ripple: false,
                                        class: "oss-list-item",
                                        readonly: ""
                                      }, {
                                        append: _withCtx(() => [
                                          _createVNode(_component_v_checkbox, {
                                            modelValue: _ctx.selectedClients,
                                            "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.selectedClients) = $event)),
                                            class: "pa-0 ma-0",
                                            onClick: _cache[16] || (_cache[16] = _withModifiers(() => {}, ["stop"])),
                                            value: comp.id,
                                            disabled: !_ctx.isEditable
                                          }, null, 8, ["modelValue", "value", "disabled"])
                                        ]),
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_list_item_title, null, {
                                            default: _withCtx(() => [
                                              _createElementVNode("span", null, _toDisplayString(comp.name), 1)
                                            ]),
                                            _: 2
                                          }, 1024),
                                          _createVNode(_component_v_list_item_subtitle, null, {
                                            default: _withCtx(() => [
                                              _createTextVNode(_toDisplayString(_ctx.getSiretValue(comp.siret)), 1)
                                            ]),
                                            _: 2
                                          }, 1024)
                                        ]),
                                        _: 2
                                      }, 1024)
                                    ]),
                                    _: 2
                                  }, 1024))
                                }), 128))
                              ]),
                              _: 2
                            }, 1024)
                          ]),
                          _: 1
                        }, 8, ["items", "height"])
                      ]),
                      _: 1
                    }))
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_v_window_item, {
        transition: "slide-x-transition",
        value: 'payments'
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_row, { "no-gutters": "" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, { cols: "6" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_btn_back, {
                    onClick: _cache[17] || (_cache[17] = _withModifiers(($event: any) => (_ctx.profileEditionStep = 'main'), ["stop"]))
                  }),
                  _cache[51] || (_cache[51] = _createElementVNode("span", { class: "title ml-2" }, "Gestion des paiements", -1)),
                  _createVNode(_component_v_list, {
                    subheader: "",
                    class: "mt-2",
                    lines: "two"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_list_item, { class: "oss-list-item mb-2" }, {
                        prepend: _withCtx(() => [
                          _createVNode(_component_v_icon, { color: "primary" }, {
                            default: _withCtx(() => _cache[45] || (_cache[45] = [
                              _createTextVNode("$fa-building")
                            ])),
                            _: 1
                          })
                        ]),
                        append: _withCtx(() => [
                          _createVNode(_component_v_switch, {
                            modelValue: _ctx.companyUser.configuration.payments.supplier,
                            "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.companyUser.configuration.payments.supplier) = $event)),
                            "hide-details": "",
                            class: "my-0",
                            ripple: false,
                            readonly: !_ctx.isEditable
                          }, null, 8, ["modelValue", "readonly"])
                        ]),
                        default: _withCtx(() => [
                          _createVNode(_component_v_list_item_title, null, {
                            default: _withCtx(() => _cache[46] || (_cache[46] = [
                              _createTextVNode(" Fournisseurs ")
                            ])),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_list_item, { class: "oss-list-item mb-2" }, {
                        prepend: _withCtx(() => [
                          _createVNode(_component_v_icon, { color: "primary" }, {
                            default: _withCtx(() => _cache[47] || (_cache[47] = [
                              _createTextVNode("$oss-expense-report")
                            ])),
                            _: 1
                          })
                        ]),
                        append: _withCtx(() => [
                          _createVNode(_component_v_switch, {
                            modelValue: _ctx.companyUser.configuration.payments.expenseReport,
                            "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.companyUser.configuration.payments.expenseReport) = $event)),
                            "hide-details": "",
                            class: "my-0",
                            ripple: false,
                            readonly: !_ctx.isEditable
                          }, null, 8, ["modelValue", "readonly"])
                        ]),
                        default: _withCtx(() => [
                          _createVNode(_component_v_list_item_title, null, {
                            default: _withCtx(() => _cache[48] || (_cache[48] = [
                              _createTextVNode(" Note de frais ")
                            ])),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_list_item, { class: "oss-list-item mb-2" }, {
                        prepend: _withCtx(() => [
                          _createVNode(_component_v_icon, { color: "primary" }, {
                            default: _withCtx(() => _cache[49] || (_cache[49] = [
                              _createTextVNode("$fa-hand-holding-usd")
                            ])),
                            _: 1
                          })
                        ]),
                        append: _withCtx(() => [
                          _createVNode(_component_v_switch, {
                            modelValue: _ctx.companyUser.configuration.payments.salary,
                            "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.companyUser.configuration.payments.salary) = $event)),
                            "hide-details": "",
                            class: "my-0",
                            ripple: false,
                            readonly: !_ctx.isEditable
                          }, null, 8, ["modelValue", "readonly"])
                        ]),
                        default: _withCtx(() => [
                          _createVNode(_component_v_list_item_title, null, {
                            default: _withCtx(() => _cache[50] || (_cache[50] = [
                              _createTextVNode(" Salaire ")
                            ])),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_v_window_item, {
        transition: "slide-x-transition",
        value: 'validation'
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_row, { "no-gutters": "" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, { cols: "6" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_btn_back, {
                    onClick: _cache[21] || (_cache[21] = _withModifiers(($event: any) => (_ctx.profileEditionStep = 'main'), ["stop"]))
                  }),
                  _cache[54] || (_cache[54] = _createElementVNode("span", { class: "title ml-2" }, "Gestion de la validation", -1)),
                  _createVNode(_component_v_list, {
                    subheader: "",
                    class: "mt-2",
                    lines: "two"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_list_item, { class: "oss-list-item mb-2" }, {
                        prepend: _withCtx(() => [
                          _createVNode(_component_v_icon, { color: "primary" }, {
                            default: _withCtx(() => _cache[52] || (_cache[52] = [
                              _createTextVNode("$fa-building")
                            ])),
                            _: 1
                          })
                        ]),
                        append: _withCtx(() => [
                          _createVNode(_component_v_switch, {
                            modelValue: _ctx.companyUser.configuration.validation.supplier,
                            "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.companyUser.configuration.validation.supplier) = $event)),
                            "hide-details": "",
                            class: "my-0",
                            readonly: !_ctx.isEditable,
                            ripple: false
                          }, null, 8, ["modelValue", "readonly"])
                        ]),
                        default: _withCtx(() => [
                          _createVNode(_component_v_list_item_title, null, {
                            default: _withCtx(() => _cache[53] || (_cache[53] = [
                              _createTextVNode(" Fournisseurs ")
                            ])),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["modelValue"]))
}